import { IcAddLinkIcon } from '@gem/icons';

import Border from '../components/Border';
import Button from '../components/Button';

const Menu = ({ presenter }) => {
  return (
    <>
      {presenter.options.map((option) => (
        <Button
          key={option.key}
          onClick={option.onClick}
          isActive={presenter.activeKeys[option.key]}
          Icon={option.icon}
        />
      ))}
      <Border />
      <Button
        onClick={presenter.toggleLinkIcon}
        isActive={presenter.activeKeys.link}
        Icon={IcAddLinkIcon}
      />
    </>
  );
};

export default Menu;
